<template>
  <b-row>
    <b-col lg="12">
      <div
        id="container"
        class="d-flex justify-content-start"
      >
        <svg
          :width="isSmallScreen() ? '100%' : '420px'"
          :height="isSmallScreen() ? '100%' : '100%'"
          viewBox="0 0 508 359"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.3623 359L481.263 358.059H490.872H508V313.5V146V131.5V0H464H248H207.211H25.4835H0V53.2095V311.014V359H16.3623Z"
            fill="#000e10"
            fill-opacity="0.8"
          />
          <path
            id="svg2"
            opacity="0.3"
            d="M229 64H412V84H229V64Z"
            fill="#00ADE2"
            fill-opacity="0.1"
          />
          <path
            opacity="0.56"
            d="M232 69H409V79H232V69Z"
            fill="#00ADE2"
            fill-opacity="0.1"
          />
          <path
            opacity="0.3"
            d="M284 130H122V142H284V130Z"
            fill="#00ADE2"
            fill-opacity="0.1"
          />
          <path
            opacity="0.56"
            d="M281 135H125V137H281V135Z"
            fill="#00ADE2"
            fill-opacity="0.1"
          />
          <path
            d="M296 65H411V73H296V65Z"
            fill="#00F2FF"
            fill-opacity="0.1"
          />
          <path
            d="M191 131H123V134H191V131Z"
            fill="#00F2FF"
            fill-opacity="0.1"
          />
          <path
            opacity="0.3"
            d="M247 197H395V217H247V197Z"
            fill="#00ADE2"
            fill-opacity="0.1"
          />
          <path
            opacity="0.56"
            d="M250 202H392V212H250V202Z"
            fill="#00ADE2"
            fill-opacity="0.1"
          />
          <path
            opacity="0.3"
            d="M238 269H107V281H238V269Z"
            fill="#00ADE2"
            fill-opacity="0.1"
          />
          <path
            opacity="0.56"
            d="M235 274H110V276H235V274Z"
            fill="#00ADE2"
            fill-opacity="0.1"
          />
          <path
            d="M302 198H394V205H302V198Z"
            fill="#00F2FF"
            fill-opacity="0.1"
          />
          <path
            d="M162 270H108V273H162V270Z"
            fill="#00F2FF"
            fill-opacity="0.1"
          />
          <path
            id="svg2"
            d="M419 78L419 116.764L406 128.217L406 239.223L419 250.676L419 289"
            stroke="#04D5FF"
            stroke-width="3"
            stroke-linecap="round"
          />
          <path
            d="M330 281H342L334 289H322L330 281Z"
            fill="url(#paint0_linear_0_1)"
            fill-opacity="0.6"
          />
          <path
            d="M346 281H358L350 289H338L346 281Z"
            fill="url(#paint1_linear_0_1)"
            fill-opacity="0.6"
          />
          <path
            d="M362 281H374L366 289H354L362 281Z"
            fill="url(#paint2_linear_0_1)"
            fill-opacity="0.6"
          />
          <path
            d="M378 281H390L382 289H370L378 281Z"
            fill="url(#paint3_linear_0_1)"
            fill-opacity="0.6"
          />
          <path
            d="M394 281H406L398 289H386L394 281Z"
            fill="url(#paint4_linear_0_1)"
            fill-opacity="0.6"
          />
          <defs>
            <linearGradient
              id="paint0_linear_0_1"
              x1="330"
              y1="281"
              x2="330"
              y2="289"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00ADE2" />
              <stop
                offset="1"
                stop-color="#00F2FF"
              />
            </linearGradient>
            <linearGradient
              id="paint1_linear_0_1"
              x1="330"
              y1="281"
              x2="330"
              y2="289"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00ADE2" />
              <stop
                offset="1"
                stop-color="#00F2FF"
              />
            </linearGradient>
            <linearGradient
              id="paint2_linear_0_1"
              x1="330"
              y1="281"
              x2="330"
              y2="289"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00ADE2" />
              <stop
                offset="1"
                stop-color="#00F2FF"
              />
            </linearGradient>
            <linearGradient
              id="paint3_linear_0_1"
              x1="330"
              y1="281"
              x2="330"
              y2="289"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00ADE2" />
              <stop
                offset="1"
                stop-color="#00F2FF"
              />
            </linearGradient>
            <linearGradient
              id="paint4_linear_0_1"
              x1="330"
              y1="281"
              x2="330"
              y2="289"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00ADE2" />
              <stop
                offset="1"
                stop-color="#00F2FF"
              />
            </linearGradient>
          </defs>

          <!-- สถิติข้อมูลเหตุการณ์ (7 วัน) -->
          <foreignObject
            width="90%"
            height="100%"
            x="15"
            y="5"
          >
            <div>
              <svg
                width="1143"
                height="154"
                viewBox="0 0 1143 154"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.2">
                  <path
                    d="M507.159 118.184H623.083H1111V23H32L33.7942 95.7745V118.184H507.159Z"
                    fill="url(#paint0_linear_26_2)"
                    fill-opacity="0.5"
                  />
                </g>
                <g filter="url(#filter0_d_26_2)">
                  <path
                    d="M1108 123.184C1110.76 123.184 1113 120.945 1113 118.184C1113 115.422 1110.76 113.184 1108 113.184V123.184ZM30 123.184H1108V113.184H30V123.184Z"
                    fill="url(#paint1_linear_26_2)"
                  />
                </g>
                <g
                  id="bolt1"
                  filter="url(#filter1_df_26_2)"
                >
                  <path
                    d="M37.9988 25.7111C37.9408 22.9502 35.6557 20.7592 32.8949 20.8172C30.1341 20.8752 27.943 23.1603 28.001 25.9211L37.9988 25.7111ZM28.001 25.9211L30.0011 121.105L39.9989 120.895L37.9988 25.7111L28.001 25.9211Z"
                    fill="#00E7FF"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_26_2"
                    x="0"
                    y="83.1839"
                    width="1143"
                    height="70"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="15" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.183437 0 0 0 0 0.340519 0 0 0 0 0.375 0 0 0 0.49 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                  </filter>
                  <filter
                    id="filter1_df_26_2"
                    x="7.99991"
                    y="0.816069"
                    width="51.999"
                    height="140.289"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="2.5"
                      result="effect2_foregroundBlur_26_2"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_26_2"
                    x1="1111.03"
                    y1="105.071"
                    x2="33.79"
                    y2="105.071"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop />
                    <stop
                      offset="0.0810585"
                      stop-color="#000506"
                    />
                    <stop
                      offset="0.1876"
                      stop-color="#001416"
                    />
                    <stop
                      offset="0.3084"
                      stop-color="#205274"
                    />
                    <stop
                      offset="0.4397"
                      stop-color="#27628A"
                    />
                    <stop
                      offset="0.5795"
                      stop-color="#3585BB"
                    />
                    <stop
                      offset="0.724"
                      stop-color="#00A0C3"
                    />
                    <stop
                      offset="0.8554"
                      stop-color="#00B3FF"
                    />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_26_2"
                    x1="30"
                    y1="118.684"
                    x2="1108"
                    y2="118.684"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#0D6E89" />
                    <stop
                      offset="0.421"
                      stop-color="#2A929C"
                      stop-opacity="0.5"
                    />
                    <stop
                      offset="0.681"
                      stop-color="#1C6269"
                      stop-opacity="0.2"
                    />
                    <stop
                      offset="1"
                      stop-color="#2F5760"
                      stop-opacity="0.15"
                    />
                  </linearGradient>
                </defs>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="80"
                  y="40"
                >
                  <span style="font-size: 50px;">สถิติข้อมูลเหตุการณ์ที่เกิดขึ้น 7 วัน</span>
                </foreignObject>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="940"
                  y="30"
                >
                  <div id="boltX2">
                    <AnalyticSciFiStaticTotalPie />
                  </div>
                </foreignObject>
              </svg>
            </div>
          </foreignObject>

          <!-- TrafficSciFiPie -->
          <!-- <foreignObject
            width="100%"
            height="100%"
            x="158"
            y="100"
          >
            <div>
              <svg
                id="circle1"
                viewBox="0 0 35 35"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="14"
                  cy="14"
                  r="11.5"
                  stroke="url(#paint0_linear_270_4228)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_270_4228"
                    x1="6.21496"
                    y1="-2.22036e-09"
                    x2="21.785"
                    y2="28"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#1D93A4" />
                    <stop
                      offset="0.511"
                      stop-color="rgba(12, 247, 240, 1)"
                    />
                    <stop
                      offset="1"
                      stop-color="#1D93A4"
                    />
                  </linearGradient>
                </defs>
              </svg>

            </div>
          </foreignObject> -->
          <!-- <foreignObject
            width="100%"
            height="100%"
            x="168"
            y="110"
          >
            <div>
              <svg
                id="circle1-2"
                viewBox="0 0 40 40"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="14"
                  cy="14"
                  r="11.5"
                  stroke="rgba(12, 247, 240, 0.8)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_270_4228"
                    x1="6.21496"
                    y1="-2.22036e-09"
                    x2="21.785"
                    y2="28"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#1D93A4" />
                    <stop
                      offset="0.511"
                      stop-color="rgba(12, 247, 240, 1)"
                    />
                    <stop
                      offset="1"
                      stop-color="#1D93A4"
                    />
                  </linearGradient>
                </defs>
              </svg>

            </div>
          </foreignObject> -->
          <foreignObject
            width="100%"
            height="100%"
            x="16"
            y="18"
          >
            <div id="boltX2">
              <!-- <AnalyticSciFiPie /> -->
              <AnalyticProgress />
            </div>
          </foreignObject>
        </svg>
      </div>

    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol,
  // BCard,
} from 'bootstrap-vue'
// import AnalyticSciFiPie from '@/views/analyticscifi/analyticdetailfi2/AnalyticPie.vue'
import AnalyticProgress from '@/views/analyticscifi/analyticdetailfi2/AnalyticProgress.vue'
import AnalyticSciFiStaticTotalPie from '@/views/analyticscifi/analyticdetailfi2/AnalyticSciFiStaticTotalPie.vue'

export default {
  // name: 'SVGAnimation',
  components: {
    BRow,
    BCol,
    // BCard,

    // AnalyticSciFiPie,
    AnalyticProgress,
    AnalyticSciFiStaticTotalPie,
  },
  data() {
    return {
      // animate: false,

      // การนับจำนวนเร็ว
      FastCounting: {
        count: 0,
        targetCount: 9832,
        duration: 6000, // Duration in milliseconds
      },
      FastCounting2: {
        count2: 0,
        targetCount2: 2826,
        duration2: 5000, // Duration in milliseconds
      },
    }
  },
  computed: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isSmallScreen)
  },
  mounted() {
    // การนับจำนวนเร็ว
    this.startCounting1()
    this.startCounting2()

    window.addEventListener('resize', this.isSmallScreen)
    this.interval = setInterval(() => {
      window.addEventListener('resize', this.isSmallScreen)
    }, 100000)
  },
  methods: {
    isSmallScreen() {
      return window.innerWidth <= 850
    },

    // การนับจำนวนเร็ว
    startCounting1() {
      const startTime = performance.now()
      const updateCount = currentTime => {
        const elapsedTime = currentTime - startTime
        if (elapsedTime < this.FastCounting.duration) {
          this.FastCounting.count = Math.round((elapsedTime / this.FastCounting.duration) * this.FastCounting.targetCount)
          requestAnimationFrame(updateCount)
        } else {
          this.FastCounting.count = this.FastCounting.targetCount
        }
      }
      requestAnimationFrame(updateCount)
    },
    startCounting2() {
      const startTime = performance.now()
      const updateCount = currentTime => {
        const elapsedTime = currentTime - startTime
        if (elapsedTime < this.FastCounting2.duration2) {
          this.FastCounting2.count2 = Math.round((elapsedTime / this.FastCounting2.duration2) * this.FastCounting2.targetCount2)
          requestAnimationFrame(updateCount)
        } else {
          this.FastCounting2.count2 = this.FastCounting2.targetCount2
        }
      }
      requestAnimationFrame(updateCount)
    },
  },

}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

#container {
  // height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
svg {
  max-width: 100%;
  height: auto;
  background: none; /* Ensures no background color */
  fill: rgba(0, 7, 33, 0.573); /* Prevents fill patterns from having unwanted backgrounds */
}

// .full-screen-svg {
//   background-color: transparent;
//   // pointer-events: none;

//   path { // Targeting all possible shapes
//     // fill: none;
//     // stroke: #fff;
//     opacity: 0.5; // Making shapes semi-transparent
//   }
// }

// .spanblue {
//   font-size: 44px;
//   font-weight: 500;
//   color: #46E0E5;
//   text-shadow: 0 0 4px #46E0E5;
// }

#heart {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: #F06;

  width: 150px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 1, 6;
  stroke-dashoffset: 54;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 2s ease-in infinite like,
  0.8s linear 2s 2 forwards beat,
  2s ease-in-out infinite fadeStroke;
  // stroke: rgb(255, 87, 51);

  @keyframes like {
  0% {
    stroke-dashoffset: 54;
    fill: var(--grey);
  }

  70% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    fill: rgba(0, 36, 182, 0.3)
  }
}

@keyframes beat {
  0% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(0.9, 0.9);
  }

  100% {
    transform: scale(1, 1);
  }

}

@keyframes fadeStroke {
    0%, 100% {
      stroke-width: 1;
    }
    50% {
      stroke-width: 0;
    }
  }
}

#circle1 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: rgb(0, 204, 255);

  width: 200px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 16, 10;
  stroke-dashoffset: 52;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 3s ease-in infinite likecircle1,
  // 0.8s linear 2s 2 forwards beat,
  3s ease-in-out infinite fadeStrokecircle1;
  // stroke: rgb(255, 87, 51);

  @keyframes likecircle1 {
  0% {
    stroke-dashoffset: 52;
    fill: var(--grey);
  }

  70% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    // opacity: 0;
    fill: rgba(0, 176, 182, 0.0)
  }
}

@keyframes fadeStrokecircle1 {
    0%, 100% {
      stroke-width: 1;
    }
    50% {
      stroke-width: 0;
    }
  }
}
#circle1-2 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: rgb(0, 204, 255);

  width: 200px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 16, 10;
  stroke-dashoffset: 52;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 3s ease-in infinite reverse likecircle1-2,
  // 0.8s linear 2s 2 forwards beat,
  3s ease-in-out infinite reverse fadeStrokecircle1-2;
  // stroke: rgb(255, 87, 51);

  @keyframes likecircle1-2 {
  0% {
    stroke-dashoffset: 52;
    fill: var(--grey);
  }

  70% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    // opacity: 0;
    fill: rgba(0, 176, 182, 0.0)
  }
}

@keyframes fadeStrokecircle1-2 {
    0%, 100% {
      stroke-width: 1;
    }
    50% {
      stroke-width: 0;
    }
  }
}

#circle2 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: rgb(0, 204, 255);

  width: 110px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 2, 6;
  stroke-dashoffset: 56;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 10s linear infinite likecircle2;

  @keyframes likecircle2 {
  0% {
    stroke-dashoffset: 56;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  // 100% {
  //   stroke-dashoffset: 0;
  //   // opacity: 0;
  //   fill: rgba(0, 176, 182, 0.0)
  // }
}
}

#svg1 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 1.0);
  --magenta: url(#paint1_linear_238_280);

  // width: 150px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 300;
  stroke-dashoffset: 54;
  stroke-linejoin: round;
  stroke-linecap: round;
  transform-origin: center;
  animation: 2s ease-in-out infinite fadeStroke1;
  // stroke: rgb(255, 87, 51);

@keyframes fadeStroke1 {
    0%, 100% {
      stroke-width: 8;
    }
    60% {
      stroke-width: 14;
    }
    100% {
      stroke-width: 8;
    }
    20% {
      stroke-width: 4;
    }
  }
}

#svg2 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: rgb(4, 213, 255, 0.2);

  // width: 150px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 380;
  stroke-dashoffset: 54;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 10s ease-in infinite like2,
  // 0.8s linear 2s 2 forwards beat2,
  10s ease-in-out infinite fadeStroke2;
  // stroke: rgb(255, 87, 51);

  @keyframes like2 {
  0% {
    stroke-dashoffset: 380;
    fill: var(--grey);
  }

  70% {
    stroke-dashoffset: 30;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    // opacity: 0;
    // transform: translateX(-100%);
    // fill: rgba(0, 36, 182, 0.3)
  }
}

@keyframes beat2 {
  0% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(0.9, 0.9);
  }

  100% {
    transform: scale(1, 1);
  }

}

@keyframes fadeStroke2 {
    0%, 100% {
      stroke-width: 8;
    }
    40% {
      stroke-width: 4;
    }
    100% {
      stroke-width: 0;
    }
  }
}

#bolt1 {
   animation: dropInY1 6s ease forwards;
   animation-delay: 200ms;

   @keyframes dropInY1 {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    30%, 100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

#boltX2 {
   animation: dropInX2 5s ease forwards;
   animation-delay: 0ms;

   @keyframes dropInX2 {
    0% {
      opacity: 0;
      transform: translateX(-100%);
    }
    30%, 100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
#boltX3 {
   animation: dropInX3 6s ease forwards;
   animation-delay: 0ms;

   @keyframes dropInX3 {
    0%, 30% {
      opacity: 0;
      transform: translateX(-100%);
    }
    30% {
      opacity: 1;
      transform: translateX(5%);
    }
    50% {
      opacity: 1;
      transform: translateX(0);
    }
  }
}

</style>
